import { Category } from './Category';
import { Brand } from './Brand';
import { Dimensions } from './Dimensions';
import { Price } from './Price';
import { Ratings } from './Ratings';
import { Warranty } from './Warranty';
import { Grade } from './Grade';
import { ProductReview } from './ProductReview';
import { Seller } from './Seller';

// Enum para definir os status possíveis para o produto
export enum ProductStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  DISCONTINUED = 'DISCONTINUED',
}

// Modelo Principal do Produto
export interface Product {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dimensionsWeight: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dimensionsDepth: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dimensionsHeight: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dimensionsWidth: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  discount: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  imageUrl: any;
  id: string;
  name: string;
  description: string;
  stock: string;
  promotion: boolean;
  dateAt: string;
  update: string;
  sku: string;
  status: ProductStatus;
  category: Category[];
  brand: Brand;
  dimensions: Dimensions;
  imagens: string[];
  price: Price;
  ratings: Ratings[];
  review: ProductReview[];
  tags: string[];
  warranty: Warranty;
  grade: Grade[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  totalSale?: number;
  localization?: string;
  freeShipping: boolean;
  seller: Seller;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}
